<app-job-queue-list [IsAdminPage]="true"></app-job-queue-list>